
import { computed, defineComponent, onMounted } from 'vue'
import * as storage from '@/utils/storage'
import { useRoute } from 'vue-router'
import { FormType, RouterName } from '@/enum'
import { Form, useClientFormDraftAll } from '@/hooks/useClientFormDraftAll'
import { isInAppWebview } from '@/utils/native-app'

export default defineComponent({
  setup () {
    const route = useRoute()

    const formType = computed(() => route.query?.type || storage.get('formType') || '')

    const isApp = computed(() => isInAppWebview())

    // 查询全部缓存信息
    const { queryAccountInfo, queryImmigrantAccountInfo, isShowView } = useClientFormDraftAll(Form.LAYOUT, formType.value as string)

    onMounted(() => {
      const { type } = route.query
      const l = type || storage.get('formType')
      if (route.name !== RouterName.GUIDE || isApp.value) {
        if (l === FormType.OPEN_IMMIGRANT_ACCOUNT) {
          queryImmigrantAccountInfo()
        } else {
          queryAccountInfo()
        }
      } else {
        isShowView.value = true
      }
    })
    return {
      isShowView
    }
  }
})
